/* Component Dependencies */
var spaHighlightsTemplate = require('templates/spaHighlights.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'spaHighlights',
  template: {
    'spaHighlights': spaHighlightsTemplate
  }
});
